export function optionsTreeJson () {
  const items = [
    { key: '0', json: 'all' },
    { key: '1', json: 'home' },
    { key: '2', json: 'devices' },
    { key: '2-0', json: 'dashboardDevice' },
    { key: '3', json: 'groups' },
    { key: '3-0', json: 'dashboardGroup' },
    { key: '4', json: 'users' },
    { key: '5', json: 'roles' },
    { key: '6', json: 'geofences' },
    { key: '7', json: 'applications' },
    { key: '8', json: 'preferences' },
    { key: '8-0', json: 'preferencesSettings' },
    { key: '8-1', json: 'preferencesReports' },
    { key: '8-2', json: 'preferencesLosses' },
    { key: '8-3', json: 'preferencesUseTime' },
    { key: '8-4', json: 'preferencesGeofence' },
    /* { key: '8-5', json: 'preferencesRxartSecure' }, */
    { key: '8-5', json: 'preferencesAgent' },
    /* { key: '8-7', json: 'preferencesServer' }, */
    { key: '9', json: 'reports' },
    { key: '10', json: 'establishments' }
    /*,
    { key: '10', json: 'events' } ,
    { key: '10-0', json: 'softwareEvents' },
    { key: '10-1', json: 'devicesEvents' } */
    /* ,
    { key: '10', json: 'safeWeb' },
    { key: '10-0', json: 'safeWebHome' },
    { key: '10-1', json: 'safeWebLists' },
    { key: '10-2', json: 'safeWebWords' },
    { key: '10-3', json: 'safeWebPreferences' } */
  ]

  return (items)
}
